import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { ChainAuditComponent } from './chain-audit.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule
    ],
    declarations: [
        ChainAuditComponent
    ],
    providers: [],
    exports: []
})
export class ChainAuditModule {}
